
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FormLoginLine extends Vue {
  private clickLineButton() {
    this.$router.push({
      path: "/line-auth",
      query: {
        from: this.$route.fullPath,
      },
    });
  }
}
